import { RestClient } from '@/api/rest-client'
import { ChecklistSettings } from '@/api/model/checklist-settings'
import { Company } from '@/api/model/company'

export class ChecklistSettingsClient extends RestClient<ChecklistSettings> {
    collectionName = 'checklist_settings'
    parseData = ChecklistSettings.fromData

    async getForCompany(company: Company): Promise<ChecklistSettings> {
        try {
            const response = await this.client.get(`${this.basePath}/companies/${company.id}/${this.collectionName}`)
            return this.parseData(response.data) as ChecklistSettings

        } catch (error) {
            this.handleError(error)
        }
    }
}
